// extracted by mini-css-extract-plugin
export var bgImage = "_2x-w";
export var body = "_2x-v";
export var buttonBar = "_2x-5";
export var card = "_2x-0";
export var center = "_2x-10";
export var chevron = "_2x-14";
export var closeButton = "_2x-12";
export var collapseHeader = "_2x-6";
export var collapseIcon = "_2x-c";
export var collapseSection = "_2x-a";
export var collapseTitle = "_2x-9";
export var collapseTrigger = "_2x-7";
export var collapsed = "_2x-b";
export var dark = "_2x-1";
export var expandableCard = "_2x-15";
export var expandableCardTitle = "_2x-13";
export var grid = "_2x-4";
export var header = "_2x-e";
export var headerContainer = "_2x-d";
export var headerSubtitle = "_2x-j";
export var headerTitle = "_2x-f";
export var inherit = "_2x-8";
export var large = "_2x-h";
export var left = "_2x-11";
export var linkColor = "_2x-16";
export var medium = "_2x-i";
export var noPadding = "_2x-3";
export var outlined = "_2x-o";
export var scrollable = "_2x-2";
export var section = "_2x-n";
export var sectionHeader = "_2x-r";
export var selected = "_2x-p";
export var separator = "_2x-q";
export var subsection = "_2x-s";
export var subtitle = "_2x-t";
export var subtotalCollapseHeader = "_2x-x";
export var subtotalCollapseHeaderTitle = "_2x-y";
export var subtotalItem = "_2x-z";
export var table = "_2x-k";
export var tableCell = "_2x-m";
export var tableHeader = "_2x-l";
export var title = "_2x-u";
export var titleFullWidth = "_2x-g";